import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
import { Button } from 'react-bootstrap';

const LoginForm = props => {
  const { handleSubmit, pristine, submitting } = props;
  return (
    <form onSubmit={handleSubmit}> 
      <Field
        name="username"
        type="text"
        component={FormField.Input}
        placeholder="Username"
        validate={[value => value ? undefined : 'Required']}
      />
      <Field
        name="password"
        type="password"
        component={FormField.Input}
        placeholder="Password"
        validate={[value => value ? undefined : 'Required']}
      />
      <div>
        <Button bsStyle="primary" type="submit" disabled={submitting}>
          Login
        </Button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'login' // a unique identifier for this form
  // validate,                // <--- validation function given to redux-form
  // warn                     // <--- warning function given to redux-form
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/routes/login/LoginForm.js